import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "grid",
  class: "grid-stack dashboard-grid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.templates)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, (widget) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(widget.type), {
            onClick: ($event: any) => (_ctx.onWidgetClick(widget,$event)),
            key: widget.type,
            widget: widget,
            widgetMode: _ctx.WidgetMode.ADD,
            isActive: _ctx.selected.has(widget.type)
          }, null, 8 /* PROPS */, ["onClick", "widget", "widgetMode", "isActive"]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 512 /* NEED_PATCH */))
    : _createCommentVNode("v-if", true)
}